// Shared by the webapp and Cloud Functions (functions/src imports this file directly),
// so keep it free of imports and browser/Node specifics.

export type KfhTradePriceSource = 'last_trade' | 'previous_close' | 'none';

export interface KfhTradeEffectivePrice {
    price: number;
    source: KfhTradePriceSource;
}

type KfhTradePricedHolding = { lastTradePrice?: unknown; previousClosed?: unknown };

const positivePrice = (value: unknown): number | undefined => {
    const parsed = typeof value === 'number' ? value : typeof value === 'string' && value.trim() ? Number(value) : NaN;
    return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
};

/**
 * Price used to value a KFHTrade holding.
 *
 * DFN stores `lastTradePrice` as 0 when a symbol did not trade on the snapshot day, and the
 * replicator copies it unchanged, so fall back to `previousClosed` and report which one was used.
 */
export const getKfhTradeEffectivePrice = (holding: KfhTradePricedHolding | null | undefined): KfhTradeEffectivePrice => {
    const lastTrade = positivePrice(holding?.lastTradePrice);
    if (lastTrade !== undefined) return { price: lastTrade, source: 'last_trade' };
    const previousClose = positivePrice(holding?.previousClosed);
    if (previousClose !== undefined) return { price: previousClose, source: 'previous_close' };
    return { price: 0, source: 'none' };
};
